import React from "react";
import { LogoBlack, LogoDefault } from "./Logo.style";

interface ILogo {
  color: "BLACK" | "DEFAULT";
}

export default ({ color }: ILogo) =>
  color === "BLACK" ? <LogoBlack /> : <LogoDefault />;
